import { useTranslation } from "react-i18next";
import "./App.css";
import Configuration from "./panel_sections/Configuration";
import Color from "./panel_sections/Color";
import WindowSize from "./panel_sections/WindowSize";
import FixBottomHeight from "./panel_sections/FixBottomHeight";
import Mountings from "./panel_sections/Mounting";
import Close from "../src/svgs/close.svg";

function UserInterface(props) {
  const { t } = useTranslation();

  return (
    <div id="panel" className={`panel-${props.documentDirection}`}>
      <div className="window-panel">
        <div id="top-panel">
          <button id="btn-close-panel">
            <img src={Close} alt={t('alt_close_button')}></img>
          </button>
        </div>
        <Configuration />
        <Color />
        <WindowSize />
        <FixBottomHeight />
        <Mountings />
      </div>
    </div>
  );
}

export default UserInterface;
